export enum TrackingConsentStatus {
  AUTHORIZED = 'authorized',
  DENIED = 'denied',
  // TODO: T267853 - add if we implement permissions.
  // NOT_DETERMINED = 'notDetermined',
}
